import { createElement } from 'react';
import styles from './styles.scss';
import cn from 'classnames';

export type AppearanceTypes =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'clear'
  | 'reset';
export type SizeType = 'large' | 'small' | 'tiny';
export type Padding = 'none' | 'normal';
export type ColorType = 'blue' | 'grey';

export type ButtonElements = HTMLButtonElement | HTMLAnchorElement;
export type ButtonProps = React.AnchorHTMLAttributes<ButtonElements> & {
  appearance?: AppearanceTypes;
  size?: SizeType;
  disabled?: boolean;
  inverted?: boolean;
  transparent?: boolean;
  outlined?: boolean;
  colorType?: ColorType;
  padding?: Padding;
};

export const preventDefault = (e: React.MouseEvent<ButtonElements>) => e.preventDefault();
export const stopPropagation = (
  e: React.MouseEvent<ButtonElements> | React.MouseEvent<HTMLElement>
) => e.stopPropagation();

/***
 * @deprecated - Only intended for use in legacy bunldes, for RED3, use components/Button instead
 */
export default ({
  className,
  appearance,
  size,
  children,
  inverted = false,
  outlined = false,
  disabled,
  transparent = false,
  type = 'button',
  padding = 'normal',
  ...props
}: ButtonProps) =>
  createElement(
    props.href !== undefined ? 'a' : 'button',
    {
      className: cn(
        {
          [styles.primary]: !appearance || appearance === 'primary',
          [styles.secondary]: appearance === 'secondary',
          [styles.tertiary]: appearance === 'tertiary',
          [styles.quaternary]: appearance === 'quaternary',
          [styles.clear]: appearance === 'clear',
          [styles.reset]: appearance === 'reset',
          [styles.inverted]: inverted,
          [styles.outlined]: outlined,
          [styles.large]: size === 'large',
          [styles.small]: size === 'small',
          [styles.tiny]: size === 'tiny',
          [styles.noPadding]: padding === 'none',
          [styles.disabled]: disabled,
          [styles.transparent]: transparent,
          [styles.blue]: !props.colorType || props.colorType === 'blue',
          [styles.grey]: props.colorType === 'grey'
        },
        className
      ),
      ...{ ...props, type }
    },
    children
  );
